<template>
  <div class="map-page">
    <Map @map-loaded="onMapLoaded" v-bind="$attrs" ref="map">
      <MeasurementControl position="top-right" />
      <LayerControl
        position="top-left"
        ref="layerControl"
        :settings="settings"
        v-if="!settings.loading"
        :readonly="readonly"
        :title="readonly ? '' : titleLayerControl"
      >
        <template #extra-first>
          <v-toolbar height="40px" dense flat short>
            <div class="d-flex full-width align-center justify-center">
              <div class="d-flex text-center flex-grow-0">
                <div style="font-size: 16px; font-weight: 600; color: #748190;">
                  {{ titleLayerControl }}
                </div>
              </div>
            </div>
          </v-toolbar>
        </template>
        <template #extra-last="{ mapId }" v-if="!readonly">
          <BasemapCard :mapId="mapId" ref="basemap" />
        </template>
        <template #default="{ layers }">
          <AdvancedSearchPanel
            v-if="!disableAdvancedSearch"
            position="top-right"
            :layers="layers"
            @click:select="onSelectFeature"
          />
          <DrawControl position="top-right" ref="drawControl" />
          <IdentifyControl
            :layers="layers"
            position="top-right"
            @click:select="onSelectFeature"
          >
          </IdentifyControl>
          <HomeControl position="top-right" />
          <GeolocateControl position="top-right" />
          <FullScreenControl position="top-right" />
          <ZoomControl position="top-right" />
        </template>
      </LayerControl>
      <BaseMapControl
        position="bottom-left"
        :baseMaps="baseMaps"
        :controlVisible="!readonly"
      >
      </BaseMapControl>
      <!-- <HomeControl /> -->

      <MouseCoordinatesControl v-if="!isMobile" />
      <FeatureInfo ref="featuredetail" />
    </Map>
  </div>
</template>

<script>
import { isString } from 'lodash'

import { callRef } from '@/src/utils/helper'
import { API_BASEMAP, API_LAYER, API_LAYERGROUP, API_SETTING } from '@api'
import {
  BasemapCard,
  BaseMapControl,
  FullScreenControl,
  GeolocateControl,
  HomeControl,
  IdentifyControl,
  Map,
  MeasurementControl,
  MouseCoordinatesControl,
  ZoomControl,
  AdvancedSearchPanel,
  DrawControl,
} from '@components/Map'
import { BaseMapCreate } from '@models/BaseMap'

import FeatureInfo from './layer-control/FeatureInfo.vue'
import LayerControl from './layer-control/layer-control.vue'
import { LAYER_TYPE } from './layer-control/model/layer'

export default {
  components: {
    Map,
    MeasurementControl,
    FullScreenControl,
    MouseCoordinatesControl,
    ZoomControl,
    HomeControl,
    GeolocateControl,
    BaseMapControl,
    LayerControl,
    BasemapCard,
    IdentifyControl,
    FeatureInfo,
    AdvancedSearchPanel,
    DrawControl,
  },
  props: {
    readonly: Boolean,
    titleLayerControl: {
      type: String,
      default: 'Quản lý lớp bản đồ',
    },
    minZoom: {
      type: [Number, String],
      require: false,
    },
    titleMap: {
      type: String,
    },
    disableAdvancedSearch: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    minZoom(val) {
      this.$refs.map.setMinZoom(val)
    },
  },
  data: () => ({
    baseMaps: [],
    settings: {
      loading: false,
      data: {
        is_global_enable: true,
        workspaces_disabled: [],
        workspaces_enabled: [],
      },
    },
  }),
  created() {
    API_BASEMAP.list().then((res) => {
      this.baseMaps = res.data.map((x) => BaseMapCreate(x))
    })
    this.$root.$on('layer-control:show-detail', (item) => {
      this.onSelectFeature(item)
    })

    this.checkHasLayerPreview()
    this.checkHasMapPreview()
    // this.settings.loading = true
    // API_SETTING.checkEnableWMS()
    //   .then((res) => {
    //     this.settings.data = res.data
    //     this.settings.loading = false
    //     this.checkHasLayerPreview()
    //     this.checkHasMapPreview()
    //   })
    //   .finally((res) => {
    //     this.settings.loading = false
    //   })
  },
  computed: {},
  methods: {
    async checkHasLayerPreview() {
      let layer_ids = this.$route.query.layer_ids
      if (!layer_ids) {
        return
      }
      layer_ids = convertParamsToArray(layer_ids)
      let res = await API_LAYER.list({
        ids: layer_ids,
        with: 'workspace,style,datastoreDetail.fields',
      })
      let layers = res.data
      if (!layers || layers.length < 1) {
        return
      }
      callRef(
        () => {
          this.$refs.layerControl.onAddLayer({
            layers: layers.map((x) => ({
              layer_type: LAYER_TYPE.NBDS_VECTO_LAYER,
              info: x,
            })),
          })
        },
        () => this.$refs.layerControl
      )
    },
    async checkHasMapPreview() {
      let map_ids = this.$route.query.map_ids
      if (!map_ids) {
        return
      }
      map_ids = convertParamsToArray(map_ids)
      let res = await API_LAYERGROUP.list({ ids: map_ids, with: 'workspace' })
      let layerGroups = res.data
      if (!layerGroups || layerGroups.length < 1) {
        return
      }
      callRef(
        () => {
          this.$refs.layerControl.onAddLayerGroup({ layerGroups })
        },
        () => this.$refs.layerControl
      )
    },
    onSelectFeature(item) {
      if (item)
        callRef(
          () => this.$refs.featuredetail.open(item),
          () => this.$refs.featuredetail
        )
    },
    getDataSave() {
      let layers = this.$refs.layerControl.getLayers()
      return { layers }
    },
    async setDataSave({ layers = [] } = {}, settings = {}) {
      let layer_ids = layers
        .filter((x) => x.layer_type == LAYER_TYPE.NBDS_VECTO_LAYER)
        .map((x) => x.info.id)
      let data_group = layers.reduce((acc, cur) => {
        if (cur.group) {
          acc[cur.info.id] = { group: cur.group }
        }
        return acc
      }, {})
      let res = await Promise.all([
        API_LAYER.list({
          ids: layer_ids,
          with: 'workspace,style,datastoreDetail.fields',
        }).then((res) => {
          let layers_data = res.data
          if (!layers_data || layers_data.length < 1) {
            return []
          }
          layers_data = layers_data.reduce((acc, cur) => {
            acc[cur.id] = cur
            return acc
          }, {})
          return layers.map((x) => ({
            layer_type: LAYER_TYPE.NBDS_VECTO_LAYER,
            info: layers_data[x.info.id],
            group: (data_group[x.info.id] || {}).group,
          }))
        }),
      ])
      let layer_convert = res.flat()
      callRef(
        () => {
          this.$refs.layerControl.onAddLayer({
            layers: layer_convert,
          })

          if (settings) {
            if (settings.default_open_label) {
              this.$refs.layerControl.showAllLabel(true)
            }
          }
        },
        () => this.$refs.layerControl
      )
    },
    onMapLoaded(map) {
      map.on('moveend', (e) => {
        this.$emit('get-position-map', {
          center: map.getCenter(),
          zoom: map.getZoom(),
        })
      })
    },
  },
}
function convertParamsToArray(value, separator = ',') {
  if (isString(value)) {
    value = value.split(separator)
  }
  return value
}
</script>

<style scoped>
.map-page {
  position: relative;
  width: 100%;
  height: 100%;
}

.map-page > div {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
</style>
